import './tooltip.css';
import classNames from 'classnames';
import React, { JSX, ReactNode } from 'react';
import { Portal } from 'react-portal';
import { Tooltip as ReactTooltip, PlacesType } from 'react-tooltip';

interface BaseProps {
  children?: ReactNode;
}
export interface TooltipProps extends BaseProps {
  content: ReactNode;
  mode?: 'dark' | 'light';
  arrow?: boolean;
  disabled?: boolean;
  placement?: PlacesType;
  visible?: boolean;
}

/**
 * Basic tooltip implementation using react-tooltip
 *
 * @see https://react-tooltip.com/
 */
export default function Tooltip({
  children,
  content,
  mode = 'light',
  arrow = true,
  disabled = false,
  placement = 'top',
  visible,
}: TooltipProps): JSX.Element {
  const tooltipId = React.useId();

  if (disabled) {
    return <>{children}</>;
  }

  return (
    <>
      <div data-tooltip-id={tooltipId} className='w-auto'>
        {children}
      </div>
      <Portal node={document && document.body}>
        <ReactTooltip
          id={tooltipId}
          place={placement}
          isOpen={visible}
          className={classNames('!rounded-lg !border !shadow-sm !text-sm !p-2 z-[999]', {
            '!bg-white !text-gray-900 !border-gray-200': mode === 'light',
            '!bg-gray-700 !text-white !border-gray-100': mode === 'dark',
          })}
          noArrow={!arrow}
        >
          {content}
        </ReactTooltip>
      </Portal>
    </>
  );
}
